<template>
  <div class="hall-list" id="hall-list">
     <!-- <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      > -->
   <div v-for="(item, index) in data"
         :key="index"
         class="hall-item clearfix"
         @click="selectHall(item)">
      <div class="item-index">{{ index + 1 }}</div>
      <div class="item-main">
        <div style="overflow: hidden;">
          <div class="item-image"
             v-if="(item.siteType == 'D006'||item.siteType == 'D007'||item.siteType == 'D008'||item.siteType == 'D009')&&item.image"
             :style="{ background: formatBg1(item.image) }"></div>
          <div class="item-image"
             v-else-if="item.image"
             :style="{ background: formatBg(item.image) }"></div>
          <div class="item-image tcc"
              v-if="item.siteType == 'D006'&&item.image==undefined"></div>
          <div class="item-image gc"
               v-else-if=" item.siteType == 'D009'&&item.image==undefined"></div>
          <div class="item-image gy"
               v-else-if=" item.siteType == 'D007'&&item.image==undefined"></div>
          <div class="item-image cdz"
               v-else-if=" item.siteType == 'D008'&&item.image==undefined"></div>
          <div class="item-image yyjh"
             v-else-if="item.siteType =='D005'&&item.image==undefined"></div>
          <div class="item-image yb"
             v-else-if="(item.siteType =='D010'&&item.image==undefined)||item.image==''"></div>
          <div class="item-image xu-banner"
               v-else-if="item.image==''||item.image==undefined"></div>
          <div class="item-info">
            <div class="item-name">{{ item.name }}</div>
            <div>
              <div style="float:left; width:79%; min-height:60px">
                <div class="item-type"> 
                  <span v-if="item.hallModeName=='政务服务中心'" style="color:#e97b77">全市通办服务大厅<br></span>
                  {{ item.type }}</div>
                <div class="item-distance item-type" v-if="(!itemInfo || !itemInfo.depart) && item.distance">距离：{{getDistance(item)}}km</div>
                <div class="item-type" v-if="itemInfo && itemInfo.depart">
                    <!-- <el-button type="primary" plain size="mini" @click.stop="event => onlineAppointMent(item, event)">在线预约</el-button> -->
                    <el-button type="primary" plain size="mini" @click.stop="onlineAppointMent(item)">在线预约</el-button>
                </div>
              </div>
              <!-- 新增列表右侧导航图标 -->
              <div class="dh" v-if="!isMobile"  style="float:left; width:20%; height:50px">
                <!-- <img @click.stop="handleNav(index)" :src="src" style="width:30px; height:30px; " alt=""> -->
              </div>
                <div class="mask" v-show="show" @click.stop="setMaskShow"></div>
                <div class="child" id="child" v-show="show"  @click.stop>
                  <div class="title item">请选择已经安装的app</div>
                  <!-- <a :href="pgUrl" v-if="isiOS" @click="its()" class="pg item">苹果自带地图</a> -->
                  <a :href="igaodeUrl" v-if="isiOS" class="gaode item">高德地图</a>
                  <a :href="gaodeUrl" v-if="!isiOS" class="gaode item">高德地图</a>
                  <a :href="baiduUrl" v-if="!isiOS" @click="ts()" class="baidu item">百度地图</a>
                  <a :href="ibaiduUrl" v-if="isiOS" @click="its()" class="ibaidu item">百度地图</a>
                  <div style="display: block; margin: 10px auto 0 ">
                    <el-button type="primary" plain style="width: 80%; line-height: 20px;" size="small" @click="show = false">取消</el-button>
                  </div>
                </div>
              <!-- </div> -->
              <div class="dh" v-if="isMobile"  @click.stop="handleNav(index)" style="float:left; width:20%; height:50px;">
                  <img :src="src" style="width:30px; height:30px; ">
                </div>
                
            </div>
          </div>
        </div>
        <el-drawer
      :title="appointmentTitle"
      :class="{ 'mobile-drawer-panel': isMobileMode }"
      size="33%"
      append-to-body
      modal-append-to-body
      :visible.sync="showAppointment"
      :direction="'rtl'"
      :before-close="handleAppointmentClose">
      <div class="appoint-header" slot="title">{{appointmentTitle}}</div>
      <div class="appoint-drawer-wrap">
        <div class="item-info">
          <div class="label">{{appointItem.projectName}}</div>
          <div class="sub-label">{{appointItem.hallName}}</div>
        </div>
        <div class="step-wrap">
          <div class="label"><i class="ri-arrow-right-circle-line"></i>请选择时间</div>
          <el-form ref="form1" :model="appointForm" :rules="appointFormRules" label-width="80px">
            <el-form-item label="" label-width="0" prop="date">
              <el-date-picker
                style="width: 100%"
                v-model="appointForm.date"
                type="date"
                @change="getAppointTimeList"
                :pickerOptions="pickerOptions"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="" label-width="0" prop="period">
              <div class="order-period">
                <template v-if="!loadingAppointmentTime && appointmentTimeList.length">
                  <div :class="['period', {active: item === currentPeriod}]" v-for="(item, i) in appointmentTimeList" :key="i" @click="selectPeriod(item, i)">
                    <div class="time">{{item.timeRange}}</div>
                    <div class="time"><span class="hign-light">{{item.leftNum}}</span>个余号</div>
                  </div>
                </template>
                <template v-if="appointForm.date && loadingAppointmentTime">
                  <div class="no-data">正在加载此预约时间信息...</div>
                </template>
                <template v-if="appointForm.date && !loadingAppointmentTime && !appointmentTimeList.length">
                  <div class="no-data">无此预约时间信息</div>
                </template>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="step-wrap">
          <div class="label"><i class="ri-arrow-right-circle-line"></i>请填写信息</div>
          <el-form ref="form2" :model="appointForm" :rules="appointFormRules" label-width="80px">
            <el-form-item label="姓名" prop="userName">
              <el-input v-model="appointForm.userName"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="userCardNo">
              <el-input v-model="appointForm.userCardNo"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="userPhone">
              <el-input v-model="appointForm.userPhone"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="btn-wrap">
          <el-button type="" @click="clearAppointForm">取消</el-button>
          <el-button type="danger" @click="submitAppointment" :loading="appointSubmitLoading">提交</el-button>
        </div>
      </div>
    </el-drawer>
        <!-- <div class="item-tag"
             v-if="item.tag && item.tag.length">
          <i class="tag-item"
             v-for="tagItem in item.tag"
             :key="tagItem"><i class="ri-checkbox-circle-line"></i>{{ tagItem }}</i>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast, List } from "vant";
// import { Popup } from 'vant';
import mapUtil from "@/api/mapUtil";
import { mapGetters } from "vuex";
import hallMixins from "@/mixins/hallMixins";
import {
  getAppointTimeList,
  submitAppointment,
} from "@/api/appointment.api.js";
Vue.use(List);
// Vue.use(Popup);
import Bus from "@/api/bus";
// Vue.use(Popup);
import {
  HALL_URLTYPE,
  WECHAT_URL,
  WECHAT_SYS,
  service_url,
  accessToken
} from "@/api/config";
import {
  getSiteInfo,
  getPriorProjectListByItemCode,
  getPriorProjectInfo
} from "@/api/hallApi";
export default {
  name: "HallList",
  mixins: [hallMixins],
  components: {
    HallFluency: () => import("@comp/HallFluency")
  },
  props: {
    prefix: {
      type: String,
      default: "-"
    },
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    itemInfo: {
      type: Object,
      default() {
        return null;
      }
    },
    itemCode: {},
    isMobileMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      appointmentTitle: "在线预约",
      appointItem: {},
      // showAppointment: false,
      appointForm: {
        userName: "",
        userCardNo: "",
        userPhone: "",
        date: "",
        period: ""
      },
      appointFormRules: {
        userName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        userCardNo: [
          { required: true, message: "请输入身份证号", trigger: "blur" }
        ],
        userPhone: [
          { required: true, message: "请输入手机号", trigger: "blur" }
        ],
        date: [{ required: true, message: "请选择日期", trigger: "blur" }],
        period: [{ required: true, message: "请选择时间段", trigger: "blur" }]
      },
      appointmentTimeList: [
        // { time: "08:30 - 09:00", num: 6 },
        // { time: "09:00 - 11:00", num: 14 },
        // { time: "11:00 - 13:00", num: 8 },
        // { time: "13:00 - 15:00", num: 6 },
        // { time: "15:00 - 17:00", num: 10 },
        // { time: "17:00 - 17:30", num: 2 },
      ],
      currentPeriod: null,
      loadingAppointmentTime: false,
      pickerOptions: {
        disabledDate(time) {
          var d = time.getDay();
          return !(time.getTime() > Date.now() && d != 6 && d != 0);
        }
      },
      appointSubmitLoading: false,
      loading: false, // 滚动加载中
      finished: false,
      isLoading: false,
      bankSwitch: false,
      show: false,
      item: "",
      imgUrl: process.env.VUE_APP_HALL_IMG_URL,
      src: require("@/assets/images/map/go.png"),
      url: require("@/assets/images/ban.png"),
      isMobile: navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    };
  },
  watch: {
    itemCode(newValue) {
      const that = this;
      if (typeof newValue == "object") {
        that.getAppointmentItemInfo();
        return;
      }
      if (newValue) {
        that.currentMode = "window";
      } else {
        that.currentMode = "hall";
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.bodyCloseMenus);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.bodyCloseMenus);
  },
  computed: {
    ...mapGetters(['zxblStatus']),
    igaodeUrl() {
      let longitude = this.item.longitude,
        latitude = this.item.latitude;
      if (this.item.siteType == "D006") {
        (longitude = this.bMapTransQQMap(longitude, latitude).lng),
          (latitude = this.bMapTransQQMap(longitude, latitude).lat);
      }
      let name = "";
      if (this.item.hallName) {
        name = this.item.hallName;
      } else {
        name = this.item.siteName;
      }
      return (
        "iosamap://path?sourceApplication=applicationName&did=&dlat=" +
        latitude +
        "&dlon=" +
        longitude +
        "&dname=" +
        name +
        "&dev=0&t=0"
      );
      //return `iosamap://navi?sourceApplication=amap&poiname=&poiid=&lat=${latitude}&lon=${longitude}&dev=1&style=2`
    },
    pgUrl() {
      let longitude = this.item.longitude,
        latitude = this.item.latitude;
      if (this.item.siteType == "D006") {
        (longitude = this.bMapTransQQMap(longitude, latitude).lng),
          (latitude = this.bMapTransQQMap(longitude, latitude).lat);
      }
      let name = "";
      if (this.item.hallName) {
        name = this.item.hallName;
      } else {
        name = this.item.siteName;
      }
      return `http://maps.apple.com/maps?saddr=&daddr=${name}`;
    },
    gaodeUrl() {
      let longitude = this.item.longitude,
        latitude = this.item.latitude;
      if (this.item.siteType == "D006") {
        (longitude = this.bMapTransQQMap(longitude, latitude).lng),
          (latitude = this.bMapTransQQMap(longitude, latitude).lat);
      }
      let name = "";
      if (this.item.hallName) {
        name = this.item.hallName;
      } else {
        name = this.item.siteName;
      }
      return (
        "amapuri://route/plan/?sid=&slat=&slon=&sname=&did=&dlat=" +
        latitude +
        "&dlon=" +
        longitude +
        "&dname=" +
        name +
        "&dev=0&t=0"
      );
    },
    baiduUrl() {
      let longitude = this.item.longitude,
        latitude = this.item.latitude;
      let lngs = "";
      let lats = "";
      if (this.item.siteType == "D006") {
        (lngs = this.item.longitude), (lats = this.item.latitude);
      } else {
        lngs = this.qqMapTransBMap(longitude, latitude).lng;
        lats = this.qqMapTransBMap(longitude, latitude).lat;
      }
      let name = "";
      if (this.item.hallName) {
        name = this.item.hallName;
      } else {
        name = this.item.siteName;
      }
      let url = "";
      url =
        "bdapp://map/direction?origin=&destination=name:" +
        name +
        "|latlng:" +
        lats +
        "," +
        lngs +
        "&mode=driving&src=andr.baidu.openAPIdemo";
      //url="bdapp://map/direction?origin=&destination=" + name + "&mode=driving&src=andr.baidu.openAPIdemo";
      // if (url != "") {
      //   window.open(url, "_blank");
      // }
      return url;
    },
    ibaiduUrl() {
      let longitude = this.item.longitude,
        latitude = this.item.latitude;
      let lngs = "";
      let lats = "";
      if (this.item.siteType == "D006") {
        (lngs = this.item.longitude), (lats = this.item.latitude);
      } else {
        lngs = this.qqMapTransBMap(longitude, latitude).lng;
        lats = this.qqMapTransBMap(longitude, latitude).lat;
      }
      let name = "";
      if (this.item.hallName) {
        name = this.item.hallName;
      } else {
        name = this.item.siteName;
      }
      let url = "";
      url =
        "baidumap://map/direction?origin=&destination=name:" +
        name +
        "|latlng:" +
        lats +
        "," +
        lngs +
        "&mode=driving&src=ios.baidu.openAPIdemo";
      // url =
      //   "bdapp://map/direction?origin=&destination=name:" +
      //   name +
      //   "|latlng:" +
      //   lats +
      //   "," +
      //   lngs +
      //   "&mode=driving&src=andr.baidu.openAPIdemo";
      // url="bdapp://map/direction?origin=&destination=" +
      //     name +
      //     "&mode=driving&src=andr.baidu.openAPIdemo";
      // window.open(url, "_blank");
      return url;
    },
    isiOS() {
      const u = navigator.userAgent;
      return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    }
  },
  methods: {
    getAppointmentItemInfo() {
      console.log("event222", this.itemInfo);
      let itemInfo = this.itemInfo;
      let find = itemInfo.departList.find(d => d.label == itemInfo.depart);
      let lastCode = find ? find.value : itemInfo.depart;
      getPriorProjectListByItemCode({
        itemCode: `${
          this.itemInfo.matterInfo.ItemInfo[0].FIRST_CODE
        }_${lastCode}`
      })
        .then(res => {
          console.log("getPriorProjectListByItemCode");
          console.log(res);

          if (res.data && res.data.rows) {
            // debugger
            let find = res.data.rows.find(info => {
              let { hallInfo, projectInfo, dateInfo } = info;
              return projectInfo.regionCode == this.itemInfo.region;
            });
            // for(var i=0;i< res.data.rows.length;i++){
            //   if(projectInfo.regionCode == this.itemCode.region)
            // }
            // let find=res.data.rows
            console.log("find.projectInfo.projectId",find)
            if (!find) return;
            getPriorProjectInfo({
              projectId: find.projectInfo.projectId
            })
              .then(res => {
                console.log("getPriorProjectInfo");
                console.log(res);
                let { info } = res.data;

                if (info && info.projectInfo) {
                  this.appointItem = info.projectInfo;
                  this.showAppointment = true;
                }
              })
              .catch(err => {})
              .finally(() => {});
          }
        })
        .catch(err => {})
        .finally(() => {});
    },
    getAppointTimeList() {
      if (!this.appointForm.date) return;
      this.loadingAppointmentTime = true;
      getAppointTimeList({
        projectId: this.appointItem.projectId,
        rDate: this.appointForm.date
      })
        .then(res => {
          if (res.data && res.data.info && res.data.info.ruleList) {
            this.appointmentTimeList = res.data.info.ruleList;
          } else {
            this.appointmentTimeList = [];
          }
        })
        .catch(err => {
          this.appointmentTimeList = [];
        })
        .finally(() => {
          this.loadingAppointmentTime = false;
        });
    },
    selectPeriod(item, i) {
      this.currentPeriod = item;
      this.appointForm.period = item.timeRange;
    },
    handleAppointmentClose(done) {
      this.clearAppointForm();
      // this.$confirm('确认关闭？')
      // .then(_ => {
      done();
      // })
      // .catch(_ => {});
      // }
    },
    clearAppointForm() {
      this.appointForm = {
        userName: "",
        userCardNo: "",
        userPhone: "",
        date: "",
        period: ""
      };
      this.appointmentTimeList = [];
      this.loadingAppointmentTime = false;
      this.appointSubmitLoading = false;
      this.showAppointment = false;
    },
    submitAppointment() {
      this.$refs.form1.validate((valid, params) => {
        if (!this.appointForm.period) {
          params.period = [
            {
              message: "请选择时间段",
              field: "period"
            }
          ];
          return false;
        }
        this.$refs.form2.validate(vali => {
          if (valid && vali) {
            this.appointSubmitLoading = true;
            submitAppointment({
              ruleId: this.currentPeriod.ruleId,
              projectId: this.appointItem.projectId,
              userName: this.appointForm.userName,
              userPhone: this.appointForm.userPhone,
              userCardNo: this.appointForm.userCardNo,
              cardType: "10",
              dataFrom: "1",
              configParam: {}
            })
              .then(res => {
                this.appointSubmitLoading = false;
                Notification.success({ title: "成功", message: "预约成功" });
                setTimeout(() => {
                  this.clearAppointForm();
                  this.showAppointment = false;
                }, 1000);
              })
              .catch(err => {
                Notification.error({ title: "失败", message: "预约失败" });
                this.appointSubmitLoading = false;
              });
          }
        });
      });
    },
    getDistance(item) {
      if (item.distance === undefined) {
        return "无数据";
      }
      if (item.distance === 0) {
        return "0";
      }
      return Number(item.distance / 1000).toFixed(2);
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      var res = localStorage.getItem("res");
      setTimeout(() => {
        // for (let i = 0; i < 0; i++) {
        //   this.list.push(this.list.length + 1);
        // }
        const that = this;
        // 加载状态结束
        that.loading = false;
        // 数据全部加载完成
        if (that.data.length >= res) {
          that.finished = true;
          that.loading = false;
        }
      }, 1000);
    },
    ts() {
      var loadDateTime = new Date();
      window.setTimeout(function() {
        var timeOutDateTime = new Date();
        if (timeOutDateTime - loadDateTime < 5000) {
          Toast("未检测到百度地图客户端，请安装后重试");
          // window.location=url;
        } else {
          window.close();
          // Toast("请先安装百度地图");
        }
      }, 1000);
    },
    its() {
      var loadDateTime = new Date();
      window.setTimeout(function() {
        var timeOutDateTime = new Date();
        if (timeOutDateTime - loadDateTime < 6000) {
          Toast("未检测到苹果地图客户端，请安装后重试");
          // 找不到app时执行的操作
        }
      }, 3000);
    },
    bodyCloseMenus(e) {
      let self = this;
      if (self.bankSwitch == true) {
        self.bankSwitch = false;
      }
    },
    qqMapTransBMap(lng, lat) {
      let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
      let x = lng;
      let y = lat;
      let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta) + 0.0065;
      let lats = z * Math.sin(theta) + 0.006;
      return {
        lng: lngs,
        lat: lats
      };
    },
    bMapTransQQMap(lng, lat) {
      let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
      let x = lng - 0.0065;
      let y = lat - 0.006;
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta);
      let lats = z * Math.sin(theta);

      return {
        lng: lngs,
        lat: lats
      };
    },
    handleNav(i) {
      const that = this;
      that.data[i].dist=''
      that.$emit("show-nav", that.data[i]);
    },
    setMaskShow() {
      this.show = !this.show;
      this.$emit("cancelBar");
    },
    setMaskShow_(item) {
      const that = this;
      that.$emit("active", item);
      this.show = !this.show;
      this.item = item;
    },
    showPopup() {
      this.show = true;
    },
    getSiteInfo() {
      let that = this;
      getSiteInfo(params)
        .then(res => {
          // {
          //   "state": 1,
          //   "message": "",
          //   "info": {
          //     "siteId": "702471072380878848",//地点ID
          //         "siteCode": "GZ_ZWFWZX",//地点编码
          //     "siteName": "广州市政务服务中心",//地点名称
          //     "siteEnglishName": "GZZWFWZX",//地点英文名称
          //     "regionCode": "440100",//区划编码
          //     "regionName": "广州市",//取号名称
          //     "siteType": "major",//市政服务类型，详细见数据字典3.10
          //     "siteTypeName": "税务",//市政服务类型名称
          //     "isReserve": "1",//是否开展预约，1是0否
          //     "workTimeRange": "周一至周五上班时间9:00到17:30，周末不上班",//工作时间
          //     "introduction": "<p>请仔细阅读预约须知</p>",//地点介绍
          //     "phone": "15055045503",//地点联系电话
          //     "complaintPhone": "075533948918",//地点投诉电话
          //     "address": "广东省广州市越秀区大德路258号",//地点地址
          //     "subwayRoute": "地铁5号线、7号线",//地铁线路
          //     "busRoute": "178路，56路",//公交线路
          //     "longitude": "113.326911",//大厅经纬度（经度）
          //     "latitude": "23.12388",//大厅经纬度（维度）
          //     "distance": 0,// 用户与地点的距离（单位米）
          //     "image": "033737cd-1538-11ec-82f8-fa163ed1ebf0.jpg",//缩略图网盘存储UID
          //     "labelNames": [
          //         "母婴室",
          //         "无线上网",
          //         "茶水间",
          //         "免费停车",
          //         "自动售卖机",
          //         "无线充电",
          //         "休息区",
          //         "24小时终端",
          //         "前台消毒洗手液"
          //     ],//大厅标签列表
          //     "scenePictures": {
          //       "frontDoor": {
          //           "name": "正门",//实景分类名称
          //           "pictures": [ "033737cd-1538-11ec-82f8-fa163ed1ebf0.jpg"] //实景图片网盘存储UID数组
          //       },
          //       "internal": {
          //           "name": "内景",
          //           "pictures": []
          //       },
          //      "appearance": {
          //           "name": "外景",
          //           "pictures": []
          //      }
          //   }//地点实景图片
          // }
          // let {state, info, message} = res // 测试
          let { state, info, message } = res.data || {};
          if (state == 1) {
            that.hallDetail = info;
          } else {
            Notification.error({
              title: "错误",
              message: message || "大厅信息获取失败"
            });
          }
          that.loading = false;
          that.$emit("stopLoading");
        })
        .catch(err => {
          let { message } = err;
          that.loading = false;
          that.$emit("stopLoading");
          Notification.error({
            title: "错误",
            message: message || "信息获取失败了"
          });
        });
    },
    selectHall(hallItem) {
      const that =this
      Bus.$emit("val", false);
      Bus.$emit("data", hallItem)
      that.$emit("selectHall", hallItem);
      if(that.zxblStatus=='XCBL'){
        // debugger
        that.currentHall = null
        that.$emit('show-nav', hallItem)
      }
    },
    onlineAppointMent(item) {
      this.getAppointmentItemInfo();
      // event.preventDefault()
      // event.stopPropagation()
      // let find = this.itemInfo.departList.find(d => d.label == this.itemInfo.depart)
      // let lastCode = find ? find.value : this.itemInfo.depart
      // this.itemInfo.code = `${this.itemInfo.matterInfo.ItemInfo[0].FIRST_CODE}_${lastCode}`
      // this.currentItem = {...this.itemInfo}
      // this.appointItem.projectName=this.itemInfo.NAME
      // this.appointItem.projectId = this.itemInfo.ID
      // this.appointItem.hallName=this.itemInfo.depart
      this.showAppointment = true;
      let userInfo = this.$store.state.userInfo;
      this.appointForm.userName = userInfo.name || "";
      this.appointForm.userPhone = userInfo.phone || "";
      this.appointForm.userCardNo = userInfo.cardNo || "";

      console.log("event", this.itemInfo);
      console.log("event", item);
      // this.$emit('showAppointment1', this.itemInfo, item)
    },
    uniqueKey(code) {
      return this.prefix + code;
    },
    formatBg1(image) {
      // var http=image.substr(3)
      return `url(${image}) no-repeat center`;
    },
    formatBg(image) {
      return `url('${this.loadImage(image)}') no-repeat center`;
    },
    //加载图片
    loadImage(image) {
      if (image == undefined || image == "") {
        return this.hallLogo;
      }
      let baseURL = "";
      if (HALL_URLTYPE == "1") {
        baseURL = WECHAT_URL;
        return (
          baseURL +
          "servlet/MobileAccessService?area=317&sys=" +
          WECHAT_SYS +
          "&action=fileDownload&downLoadType=download" +
          "&fileName=" +
          image
        );
      }
      if (HALL_URLTYPE == "2") {
        baseURL = "";
        return (
          baseURL +
          "/fwapi/c/api.transfer/file_Map?access_token=" +
          accessToken +
          "&fileName=" +
          image +
          "&time=12313123"
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@style/_var.scss";
@import "~@style/_theme.scss";
.mobile-index .enter-panel {
  padding-top: 42px !important;
}
.hall-list .hall-item {
  padding: 5px 16px 0px !important;
}
.hall-list .hall-item .item-flow {
  margin-top: 56px !important;
}
button {
  border: none !important;
}
.van-button--primary {
  background: #fff !important;
  position: absolute;
  right: 10px;
  width: 40px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
.van-overlay {
  background: rgba(0, 0, 0, 0.002) !important;
}
.van-overlay {
  background-color: rgba(0, 0, 0, 0.002) !important;
  z-index: 999;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
.mask {
  background-color: #fff;
  opacity: 0;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // z-index: 99999;
}
.bankItem {
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 24%;
  z-index: 9999999;
}
.pop {
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 24%;
  z-index: 9999999999;
}
// .btn {
//   background-color: #fff;
//   border-radius: 4px;
//   border: 1px solid blue;
//   padding: 4px 12px;
// }

.search-none {
  display: none;
}
.item {
  text-align: center;
  height: 40px;
  line-height: 40px;
  display: block;
  border: none;
  background: #fff;
  width: 100%;
  color: #000;
}
.title {
  font-size: 14px;
  color: #c0c0c0;
}
.title,
.baidu,
.ibaidu {
  border-bottom: solid rgba(223, 221, 221, 0.986) 1px;
}
.father {
  width: 100%;
  height: 100%;
}
// .mask{
//     width: 100%;
//     height: 100%;
//     position: fixed;
//     top: 0;
//     left: 0;
//     background: #e4e7ed;
//     opacity: 0.01;
// }
// button {
//   width: 100px;
//   height: 30px;
//   line-height: 30px;
//   text-align: center;
// }
.child {
  position: fixed;
  width: 100%;
  height: 33%;
  text-align: center;
  // line-height: 400px;
  bottom: 33px;
  left: 0;
  background: #fff;
  z-index: 9999999999;
}
.hall-list {
  z-index: 0;
  -webkit-overflow-scrolling: touch;
  line-height: $lineHeight;
  .hall-item {
    padding: $paddingVertical $paddingHorizontal 12px;
    cursor: pointer;
    transition: $transitionTime;
    border-bottom: 5px solid #f5f7fa;
    .item-index {
      float: left;
      width: 40px;
      height: 40px;
      color: #fff;
      font-size: 12px;
      text-align: center;
      line-height: 30px;
      background: url("~@img/pin.png") no-repeat center;
      background-size: contain;
    }
    .item-main {
      margin-left: 24px;
    }
    .gc {
      background: url("~@img/gc1.jpeg") no-repeat center;
    }
    .tcc {
      background: url("~@img/tcc.jpg") no-repeat center;
    }
    .gy {
      background: url("~@img/gy.jpg") no-repeat center;
    }
    .cdz {
      background: url("~@img/cdz.jpg") no-repeat center;
    }
    .yyjh {
      background: url("~@img/yyjh.jpg") no-repeat center;
    }
    .yb {
      background: url("~@img/yb.jpg") no-repeat center;
    }
    .xu-banner {
      background: url("~@img/moren.jpg") no-repeat center;
    }
    .item-image {
      float: left;
      width: 72px;
      height: 72px;
      background-color: #eee;
      background-size: cover !important;
      & ~ .item-info {
        margin-left: 80px;
      }
    }

    .item-name {
      margin-bottom: 4px;
      font-weight: 500;
      color: $colorTextPrimary;
      overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;
    }
    .item-type {
      font-size: 12px;
      font-weight: 400;
      color: $colorTextSecondary;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .item-flow {
      margin-top: 12px;
    }
    &:hover {
      background-color: #f5f7fa;
      .item-index {
        background-image: url("~@img/pin-active.png");
      }
    }
    .item-tag {
      margin-top: 8px;
    }
  }
  .tag-item {
    display: inline-block;
    height: 24px;
    margin-right: 12px;
    margin-bottom: 4px;
    line-height: 22px;
    font-size: 12px;
    font-style: normal;
    color: $colorTextRegular;
    i {
      margin-right: 4px;
      vertical-align: -1px;
      color: $colorPrimary;
    }
    // background: #F5F8FC;
    // border: 1px solid #E9E9EB;
    // border-radius: 2px;
  }
}
.mobile-drawer-panel {
  ::v-deep .el-drawer {
    width: 100% !important;
  }
}
.appoint-header {
  color: #000;
}
.appoint-drawer-wrap {
  width: calc(100% - 10vw);
  margin: auto;

  .item-info {
    .label {
      font-size: 20px;
    }

    .sub-label {
      color: #919398;
    }
  }

  .step-wrap {
    padding: 16px 16px;
    background: #fff;
    box-shadow: 0 1px 10px 0 rgb(210 219 231 / 60%);
    border-radius: 6px;
    margin-top: 20px;
    padding-bottom: 1px;

    .label {
      margin-bottom: 8px;
      color: #1f2026;
      i {
        margin-right: 4px;
        font-size: 16px;
        color: #d4000b;
        vertical-align: -3px;
      }
    }
  }

  .btn-wrap {
    margin-top: 20px;
    text-align: center;
  }
}

.order-period {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  .period {
    width: 30%;
    text-align: center;
    border: 1px solid #e4e4e4;
    border-radius: 5px;
    margin-bottom: 14px;
    line-height: 26px;

    &.active {
      background: #f33942;
      color: #fff;
    }
  }
}
.mobile-drawer-panel {
  ::v-deep .el-drawer {
    width: 100% !important;
  }
}
.appoint-header {
  color: #000;
}
.appoint-drawer-wrap {
  width: calc(100% - 10vw);
  margin: auto;

  .item-info {
    .label {
      font-size: 20px;
    }

    .sub-label {
      color: #919398;
    }
  }

  .step-wrap {
    padding: 16px 16px;
    background: #fff;
    box-shadow: 0 1px 10px 0 rgb(210 219 231 / 60%);
    border-radius: 6px;
    margin-top: 20px;
    padding-bottom: 1px;

    .label {
      margin-bottom: 8px;
      color: #1f2026;
      i {
        margin-right: 4px;
        font-size: 16px;
        color: #d4000b;
        vertical-align: -3px;
      }
    }
  }

  .btn-wrap {
    margin-top: 20px;
    text-align: center;
  }
}

.order-period {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  .period {
    width: 30%;
    text-align: center;
    border: 1px solid #e4e4e4;
    border-radius: 5px;
    margin-bottom: 14px;
    line-height: 26px;

    &.active {
      background: #f33942;
      color: #fff;
    }
  }
}
::v-deep .el-drawer__wrapper {
  z-index: 9999;
  height: 100%;
}
::v-deep .el-drawer__header {
  background: transparent;
  margin-bottom: 0;
  padding-bottom: 20px;
}

::v-deep .el-drawer.rtl {
  padding-bottom: 30px;
  background: url("~@img/ratepanelbg-red.png") no-repeat center top;
  background-size: 100% auto;
  border-bottom: none;
  background-color: #fff;
}
</style>
